import { TimePeriodId } from '@/models/time-period';
import { PeriodTabsOptions } from '@/enums/filter-by-period';

export default function usePeriodId(tab?: PeriodTabsOptions) {
  const periodId = (() => {
    switch (tab) {
      case PeriodTabsOptions.OneDay:
        return TimePeriodId.Today;
      case PeriodTabsOptions.ThreeDays:
        return TimePeriodId.ThreeDays;
      case PeriodTabsOptions.OneWeek:
        return TimePeriodId.OneWeek;
      default:
        return TimePeriodId.Today;
    }
  })();

  return {
    periodId,
  };
}
